import React, { useState, useEffect } from "react";
import { connect } from "react-redux";

import { withRouter } from "utils/WithRouter";

import Spinner from "../../components/generics/Spinner";
import { InventoryAuditHeader } from "../../components/inventories/InventoryAuditEdit";
import InventoryAuditResult from "../../components/inventories/InventoryAuditResult";
import ModalUploadR365File from "../../components/inventories/ModalUploadR365File";

import { fetchAudit, fetchAuditSuccess, fetchAuditFailure } from "../../store/inventories/actions";

import { fetchInventoryAuditXLS, fetchInventoryR365AuditXLS, fetchInventoryR365AuditXLSJoined } from "../../store/inventories/api";

const InventoryAuditViewContainer = ({ match, inventoryAudit, fetchAudit }) => {
  const [isXlsLoading, setIsXlsLoading] = useState(false);
  const [isR365xlsLoading, setIsR365xlsLoading] = useState(false);
  const [isR365UploadLoading, setIsR365UploadLoading] = useState(false);
  const [isOpenUploadR365FileModal, setIsOpenUploadR365FileModal] = useState(false);

  useEffect(() => {
    fetchAudit(match.params.id);
  }, []);

  const toggleUploadR365FileModal = () => {
    setIsOpenUploadR365FileModal(!isOpenUploadR365FileModal);
  };

  const loadInventoryAuditXLS = () => {
    const auditId = inventoryAudit.audit.id;
    let fileName = `audit_${auditId}.xls`;
    setIsXlsLoading(true);
    fetchInventoryAuditXLS(inventoryAudit.audit.id)
      .then((r) => {
        let blob = new Blob([r.data], { type: "application/vnd.ms-excel" });
        let link = document.createElement("a");
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        link.click();
        document.body.removeChild(link);
        setIsXlsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsXlsLoading(false);
      });
  };

  const loadInventoryR365AuditXLSJoined = (data) => {
    setIsOpenUploadR365FileModal(false);
    setIsR365UploadLoading(true);
    fetchInventoryR365AuditXLSJoined(inventoryAudit.audit.id, data).then((blob) => {
      const href = URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = href;
      link.setAttribute("download", "audit_R365.xlsx");
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      URL.revokeObjectURL(href);
      setIsR365UploadLoading(false);
    });
  };

  const loadInventoryAuditR365 = () => {
    setIsOpenUploadR365FileModal(false);
    let fileName = `audit_R365.xls`;
    setIsR365xlsLoading(true);
    fetchInventoryR365AuditXLS(inventoryAudit.audit.id)
      .then((r) => {
        let blob = new Blob([r.data]);
        let link = document.createElement("a");
        document.body.appendChild(link);
        link.href = window.URL.createObjectURL(blob);
        link.setAttribute("download", fileName);
        link.click();
        document.body.removeChild(link);
        setIsR365xlsLoading(false);
      })
      .catch((err) => {
        console.log(err);
        setIsR365xlsLoading(false);
      });
  };

  return inventoryAudit.loading || !inventoryAudit.audit || !inventoryAudit.audit.result ? (
    <Spinner />
  ) : (
    <div className="animated fadeIn">
      <InventoryAuditHeader
        audit={inventoryAudit.audit}
        // finishAudit={this.finishAudit}
        showFinish={false}
        loadInventoryAuditXLS={loadInventoryAuditXLS}
        loadInventoryAuditR365={loadInventoryAuditR365}
        loadInventoryAuditUpload={toggleUploadR365FileModal}
        xlsLoading={isXlsLoading}
        r365xlsLoading={isR365xlsLoading}
        r365UploadLoading={isR365UploadLoading}
      />

      {/* Scanned Not Inventoried */}
      <InventoryAuditResult
        list={inventoryAudit.audit.result.scannedNotInventoried}
        title="Scanned inactive items"
        iconClass="fa fa-exclamation-circle mr-05 color-danger fs-15"
      />

      {/* Scanned Not Existing */}
      {inventoryAudit.audit.result.scannedNotExisting && (
        <InventoryAuditResult
          list={inventoryAudit.audit.result.scannedNotExisting}
          title="Scanned not existing items"
          iconClass="fa fa-exclamation-circle mr-05 color-danger fs-15"
        />
      )}

      {/* Not Scanned */}
      <InventoryAuditResult
        list={inventoryAudit.audit.result.notScanned}
        title="Inventoried not scanned items"
        iconClass="fa fa-exclamation-triangle mr-05 color-warning fs-15"
      />

      {/* OK */}
      <InventoryAuditResult
        list={inventoryAudit.audit.result.ok}
        title="Inventoried scanned items"
        iconClass="fa fa-check-circle mr-05 color-success fs-15"
      />
      {isOpenUploadR365FileModal && (
        <ModalUploadR365File
          isModalOpen={isOpenUploadR365FileModal}
          closeModal={toggleUploadR365FileModal}
          onJoinedExport={loadInventoryR365AuditXLSJoined}
        />
      )}
    </div>
  );
};

const mapStateToProps = (state, ownProps) => {
  return {
    inventoryAudit: state.inventories.inventoryAudit,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    fetchAudit: (id) => {
      dispatch(fetchAudit(id)).payload.then(
        (response) => {
          dispatch(fetchAuditSuccess(response.data));
        },
        (error) => {
          dispatch(fetchAuditFailure(error));
        }
      );
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(InventoryAuditViewContainer));
